import React, { useState, useEffect } from 'react';
import { Label, Dropdown, Form, Message, Grid } from 'semantic-ui-react';
import DatePicker from 'react-datepicker';
import { format } from 'date-fns';
import "./statusToolsStyles.css"
/**
 * Component for displaying status labels (priority, status, deadline)
 */
export const StatusLabels = ({
  priority,
  status,
  deadline,
  getPriorityColor,
  getStatusColor
}) => {
  // Format deadline for display
  const formatDeadline = (date) => {
    if (!date) return null;
    try {
      return format(new Date(date), 'MMM d, yyyy');
    } catch (error) {
      console.error('Error formatting date:', error);
      return 'Invalid date';
    }
  };

  return (
    <div className='status-labels-container'>
      {priority && (
        <Label size="tiny" color={getPriorityColor(priority)}>
          {priority}
        </Label>
      )}
      {status && (
        <Label size="tiny" color={getStatusColor(status)}>
          {status}
        </Label>
      )}
      {deadline && (
        <Label className='padLeftStdOffset_10' size="tiny" basic>
          Due: {formatDeadline(deadline)}
        </Label>
      )}
    </div>
  );
};

/**
 * Component for editing status information (priority, status, deadline)
 */
export const StatusForm = ({
  charName,
  priority,
  setPriority,
  status,
  setStatus,
  deadline,
  setDeadline,
  priorityOptions,
  statusOptions
}) => {
  // Add local state to track deadline
  const [localDeadline, setLocalDeadline] = useState(deadline);
  const [localPriority, setLocalPriority] = useState(priority);
  const [localStatus, setLocalStatus] = useState(status);
  // Sync local state with props whenever deadline prop changes
  const characterName = charName;
  useEffect(() => {
    console.log('Priority prop changed:', priority);
    setLocalPriority(priority)
  }, [priority]);

  useEffect(() => {
    console.log('Status prop changed:', status);
    setLocalStatus(status)
  }, [status]);

  useEffect(() => {
    console.log('Deadline prop changed:', deadline);
    setLocalDeadline(deadline);
  }, [deadline]);

  // Optional debugging
  useEffect(() => {
    console.log('StatusForm render - deadline prop:', deadline);
    console.log('StatusForm render - localDeadline state:', localDeadline);
  }, [deadline, localDeadline]);

  // Handle date change with proper logging and state updates
  // const handleDateChange = (e, { value }) => {
  //   const newDate = value ? new Date(value) : null;
  //   console.log('CHANGED DEADLINE', newDate);

  //   // Update local state first
  //   setLocalDeadline(newDate);

  //   // Then update parent state/Formik
  //   setDeadline(newDate);
  // };

  // const handlePriorityChange = (e, { value }) => {
  //   console.log('CHANGED PRIORITY', value);
  //   setPriority(value);
  //   setLocalPriority(value);
  // }
  if (charName === undefined) return "";
  // Status form render

  const handleEntityChange = ({ entity, value }) => {
    console.log('CHANGED ', entity, "value", value);
    switch (entity) {
      case "priority":
        setPriority(value);
        setLocalPriority(value);
        break;
      case "status":
        setStatus(value);
        setLocalStatus(value);
        break;
      case "deadline":
        const newDate = value ? new Date(value) : null;
        console.log('CHANGED DEADLINE', newDate);

        // Update local state first
        setLocalDeadline(newDate);

        // Then update parent state/Formik
        setDeadline(newDate);
        break;
      default:
        return 'Invalid change';
    }
  }


  // Filter out the 'all' option from the dropdown options
  const filteredPriorityOptions = priorityOptions.filter(option => option.value !== 'all');
  const filteredStatusOptions = statusOptions.filter(option => option.value !== 'all');

  // Dropdown style with higher z-index to ensure they appear above other elements
  const dropdownStyle = {
    zIndex: 1000
  };

  return (
    <div className="status-form">
      <Grid className='noPad' columns={2}>
        <Grid.Row className='noPad'>
          <Grid.Column className='noPad' >
            <div className="aaifield" style={{ position: 'relative' }}>
              <label>Priority</label>
              <Dropdown
                selection
                options={priorityOptions}
                value={localPriority}
                onChange={(e, { value }) => handleEntityChange({ entity: 'priority', value })}
                fluid
                style={dropdownStyle}
                className="transparent-dropdown"

              />
            </div>
          </Grid.Column>
          <Grid.Column className='noPad'>
            <div className="aaifield" style={{ position: 'relative' }}>
              <label>Status </label>
              <Dropdown
                selection
                options={statusOptions}
                value={localStatus}
                onChange={(e, { value }) => handleEntityChange({ entity: 'status', value })}
                fluid
                style={dropdownStyle}
                className="transparent-dropdown"

              />
            </div>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row className='noPad'>
          <Grid.Column className='noPad' width={16}>
            <div className="aaifield status-date-container">
              <label className="" style={{ paddingLeft: "10px" }}>Deadline (Optional)</label>
              <DatePicker
                name="deadline"
                selected={localDeadline ? new Date(localDeadline) : null}
                onChange={(date) => handleEntityChange({ entity: 'deadline', value: date })}
                dateFormat="MM/dd/yyyy"
                isClearable
                wrapperClassName="aai-datepicker-fluid"
                className="date-input-with-popup" // Add a custom class
              />
            </div>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </div>
  );
};

/**
 * Component for filtering by status information (priority, status)
 */
export const StatusFilter = ({
  priorityFilter,
  setPriorityFilter,
  statusFilter,
  setStatusFilter,
  priorityOptions,
  statusOptions
}) => {
  // Dropdown style with higher z-index
  const dropdownStyle = {
    zIndex: 1000
  };

  return (
    <div className='status-priority-status-container'>
      <div className='status-drop-container'>
        <label className='status-drop-label'>Priority</label>
        <Dropdown
          selection
          options={priorityOptions}
          value={priorityFilter}
          onChange={(e, { value }) => setPriorityFilter(value)}
          fluid
          style={dropdownStyle}
        />
      </div>
      <div className='status-drop-container'>
        <label className='status-drop-label'>Status</label>
        <Dropdown
          selection
          options={statusOptions}
          value={statusFilter}
          onChange={(e, { value }) => setStatusFilter(value)}
          fluid
          style={dropdownStyle}
        />
      </div>
    </div>
  );
};

/**
 * Component for displaying status messages (e.g., deadline warnings)
 */
export const StatusMessage = ({
  status,
  deadline,
  isDeadlineApproaching,
  isDeadlinePast,
  getDeadlineWarning,
  getStatusColor
}) => {
  // Only show warning if status is not 'Complete'
  if (status === 'Complete' || !deadline) return null;

  if (isDeadlinePast && isDeadlinePast()) {
    return (
      <Message warning className="bw-status-message-fixed-width">
        <Message.Header ><div style={{ display: "block", minWidth: "290px !important" }}>Deadline has passed!</div></Message.Header>
        <p>This item is overdue.</p>
      </Message>
    );
  } else if (isDeadlineApproaching && isDeadlineApproaching()) {
    return (
      <Message warning className="bw-status-message-fixed-width" >
        <Message.Header>Deadline approaching!</Message.Header>
        <p>This item is due soon.</p>
      </Message>
    );
  }

  return null;
};
